/* eslint-disable no-undef */

import gallery from '../modules/gallery.js';
import navigation from '../modules/navigation.js';
import projects from '../modules/projects.js';
import luxembourgMap from '../modules/luxembourgMap.js';
import animations from '../modules/animations.js';
import floatedInput from '../modules/form.js';
import singleMap from '../modules/singleMap.js';
import hero from '../modules/hero.js';
import popup from '../modules/popup.js';

export default {
  init() {
    gallery();
    navigation();
    projects();
    luxembourgMap();
    //floatedInput();
    animations();
    singleMap();
    hero();
    popup();
  },
  finalize() {
    // Listen for part change on ninjafroms multi part forms
    $(document).on('nfFormReady', function() {
        // console.log('ninja form ready');
        floatedInput();
    nfRadio.channel( 'nfMP' ).on('change:part', function() {
        // console.log('[nfMP] change:part');
        floatedInput();
    });
  });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js